<template>
	<div>
		<table>
			<EventRow v-for="(event, index) in eventList" :key="index" :event="event" />
		</table>
	</div>
</template>


<script>
import EventRow from "@/components/event-log/EventRow.vue";

export default {
	name: "EventLog",
	components: { EventRow },
	data() {
		return {
			result: null
		};
	},
	computed: {
		eventList() {
			const list = this.$store.state.eventList;
			return list;
		}
	},
	methods: {}
};
</script>

<style scoped>
table {
	width: 100%;
}
</style>
